import { createTheme } from '@mui/material/styles';

const altviaDarkTheme = createTheme({
	palette: {
		mode: 'dark',
		primary: {
			main: '#8C8EFF',
			light: '#B0B1FF',
			dark: '#6B6DCF',
			contrastText: '#FFFFFF',
		},
		secondary: {
			main: '#67A9CF',
			light: '#98C8E1',
			dark: '#4B89AF',
			contrastText: '#FFFFFF',
		},
		background: {
			default: '#181A24', // Dark background
			paper: '#23243A',
			lightPurple: '#25253a',
			lightBlue: '#1e222d',
		},
		text: {
			primary: '#F3F6F9',
			secondary: '#B0B3C6',
			tertiary: '#767792',
		},
		accent: {
			purple: '#8C8EFF',
			teal: '#4EC5C1',
			coral: '#FF7F92',
		},
		divider: 'rgba(140, 142, 255, 0.18)',
	},
	typography: {
		fontFamily: '"Onest", "Roboto", "Helvetica", "Arial", sans-serif',
		h1: {
			fontWeight: 700,
			fontSize: '3rem',
			letterSpacing: '-0.01562em',
			color: '#F3F6F9',
		},
		h2: {
			fontWeight: 700,
			fontSize: '2.5rem',
			letterSpacing: '-0.00833em',
			color: '#F3F6F9',
		},
		h3: {
			fontWeight: 700,
			fontSize: '2rem',
			letterSpacing: '0em',
			color: '#F3F6F9',
		},
		h4: {
			fontWeight: 700,
			fontSize: '1.5rem',
			letterSpacing: '0.00735em',
			color: '#F3F6F9',
		},
		h5: {
			fontWeight: 600,
			fontSize: '1.4rem',
			letterSpacing: '0em',
			color: '#F3F6F9',
		},
		h6: {
			fontWeight: 600,
			fontSize: '1.25rem',
			letterSpacing: '0.0075em',
			color: '#F3F6F9',
		},
		subtitle1: {
			fontSize: '1rem',
			fontWeight: 500,
			letterSpacing: '0.00938em',
			color: '#B0B3C6',
		},
		subtitle2: {
			fontSize: '0.875rem',
			fontWeight: 500,
			letterSpacing: '0.00714em',
			color: '#B0B3C6',
		},
		body1: {
			fontSize: '1rem',
			letterSpacing: '0.00938em',
			color: '#F3F6F9',
			lineHeight: 1.5,
		},
		body2: {
			fontSize: '0.875rem',
			letterSpacing: '0.01071em',
			color: '#F3F6F9',
			lineHeight: 1.43,
		},
		button: {
			textTransform: 'none',
			fontWeight: 600,
			letterSpacing: '0.02857em',
		},
		caption: {
			fontSize: '0.75rem',
			letterSpacing: '0.03333em',
			color: '#B0B3C6',
		},
	},
	shape: { borderRadius: 12 },
	shadows: [
		'none',
		'0px 2px 8px rgba(140, 142, 255, 0.14)',
		'0px 4px 16px rgba(140, 142, 255, 0.2)',
		// ...copy other shadows as needed
	],
	components: {
		MuiAppBar: {
			styleOverrides: {
				root: {
					backgroundColor: '#23243A',
					color: '#F3F6F9',
					boxShadow: '0 2px 12px rgba(140, 142, 255, 0.14)',
				},
			},
		},
		MuiPaper: {
			styleOverrides: {
				root: {
					borderRadius: 16,
					backgroundColor: '#23243A',
					color: '#F3F6F9',
				},
				elevation1: { boxShadow: '0 2px 10px rgba(140, 142, 255, 0.12)' },
				elevation2: { boxShadow: '0 4px 20px rgba(140, 142, 255, 0.18)' },
				footer: { borderRadius: 0 },
			},
		},
		MuiButton: {
			styleOverrides: {
				root: {
					borderRadius: 10,
					padding: '10px 24px',
					textTransform: 'none',
					fontWeight: 600,
					color: '#F3F6F9',
				},
			},
		},
		MuiTypography: {
			styleOverrides: {
				h5: { fontWeight: 700, marginBottom: '12px', color: '#F3F6F9' },
				subtitle1: { marginBottom: '12px', color: '#B0B3C6' },
			},
		},
		MuiListItem: {
			styleOverrides: {
				root: {
					borderRadius: 8,
					marginBottom: 4,
					transition: 'all 0.2s ease',
					'&.Mui-selected': {
						backgroundColor: 'rgba(140, 142, 255, 0.18)',
					},
				},
			},
		},
		MuiSwitch: {
			styleOverrides: {
				root: { width: 42, height: 26, padding: 0, margin: 12 },
				switchBase: {
					padding: 1,
					'&.Mui-checked': {
						transform: 'translateX(16px)',
						color: '#23243A',
						'& + .MuiSwitch-track': {
							opacity: 1,
							backgroundColor: '#8C8EFF',
						},
					},
				},
				thumb: { width: 24, height: 24 },
				track: { borderRadius: 13, opacity: 1, backgroundColor: '#393B4A' },
			},
		},
		// Add more component overrides as needed
	},
});

export default altviaDarkTheme;
